export class CvsModel {
  id: number;
  content: string;
  fileName: string;
  userId: number;
  createDate: Date;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/cvs/cvs.model.ts